import { put, call, takeLatest,takeEvery } from 'redux-saga/effects';
import axios from 'axios';

function* addImportCSVData(action){
    try{
        console.log(action.payload);
        console.log(action.payload.referralPartnerId);
        yield axios.post('./api/import/', {
            //goes to client table
            name: action.payload.name,
            email: action.payload.email,
            phone: action.payload.phone,
            phone_type: action.payload.phone_type,
            address: action.payload.address,
            dob: action.payload.dob,
            gender: action.payload.gender,
            race: action.payload.race,
            marital_status: action.payload.marital_status,
            education: action.payload.education,
            veteran: action.payload.veteran,
            ability: action.payload.ability,
            household_head: action.payload.household_head,
            household_members: action.payload.household_members,
            monthly_income: action.payload.monthly_income,
            reason: action.payload.reason,
            reason_text: action.payload.reason_text,
            //goes to request table
            staff_name: action.payload.staffName,
            staff_email: action.payload.staffEmail,
            request_items: action.payload.requestedItems,
            referral_partner_id: action.payload.referralPartnerId,
            status: action.payload.clientStatus
        });
    } catch(error){
        console.log('Error in loading csv data', error);
    };
};

function* ImportCSVSaga(){
    yield takeEvery('IMPORT_CSV_DATA', addImportCSVData);
}

export default ImportCSVSaga;